module.exports = __webpack_public_path__ + "static/amp@2x-098057b30d009c5f198ee8fc346165fb.png";